import { render, staticRenderFns } from "./noSidebarLayout.vue?vue&type=template&id=72580f9d&"
import script from "./noSidebarLayout.vue?vue&type=script&lang=js&"
export * from "./noSidebarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports